/**
 * Shared tree helpers for syllabus UI (filter sidebar + subject picker).
 * Nodes: { id, label, children? }
 */

export function buildDefaultExpanded(nodes, maxOpenDepth = 2) {
  const map = {}
  const walk = (list, d) => {
    list.forEach((n) => {
      if (n.children?.length) {
        map[n.id] = d < maxOpenDepth
        walk(n.children, d + 1)
      }
    })
  }
  walk(nodes, 0)
  return map
}

export function buildExpandMap(nodes, expanded) {
  const map = {}
  const walk = (list) => {
    list.forEach((n) => {
      if (n.children?.length) {
        map[n.id] = expanded
        walk(n.children)
      }
    })
  }
  walk(nodes)
  return map
}

/** Deep-clone a node and its subtree (new object references; same ids/labels). */
function cloneNodeDeep(n) {
  if (!n.children?.length) {
    return { ...n }
  }
  return {
    ...n,
    children: n.children.map(cloneNodeDeep),
  }
}

/**
 * Returns a filtered tree: nodes whose label matches `query` keep their **full** nested
 * subtree; non-matching branches are pruned to paths where a descendant matches.
 */
export function filterTreeByLabel(nodes, query) {
  const q = query.trim().toLowerCase()
  if (!q) return nodes
  const walk = (n) => {
    const selfMatch = n.label.toLowerCase().includes(q)
    if (!n.children?.length) {
      return selfMatch ? { ...n } : null
    }
    if (selfMatch) {
      return cloneNodeDeep(n)
    }
    const kids = n.children.map(walk).filter(Boolean)
    if (kids.length) {
      return { ...n, children: kids }
    }
    return null
  }
  return nodes.map(walk).filter(Boolean)
}

export function expandAllInTree(nodes, into = {}) {
  nodes.forEach((n) => {
    if (n.children?.length) {
      into[n.id] = true
      expandAllInTree(n.children, into)
    }
  })
  return into
}
